<template>
  <div class="filter">
    <el-date-picker
      v-model="value"
      :readonly="readonly"
      :type="type"
      :format="format"
      :value-format="valueFormat"
      :default-time="defaultTime"
      @change="filter"
    />
  </div>
</template>

<script>
export default {
  name: 'RestListFilterDate',

  inject: ['restList'],

  props: {
    prop: {
      required: false
    },

    readonly: {
      type: Boolean,
      default: false
    },

    datePickerProps: {
      type: Object,
      required: false
    },

    defaultValue: {
      required: false
    }
  },

  data() {
    return {
      value: ''
    }
  },

  mounted() {
    this.value = this.defaultValue
  },

  computed: {
    type() {
      if (this.datePickerProps.type) {
        return this.datePickerProps.type
      }
    },

    defaultTime() {
      if (this.datePickerProps.defaultTime) {
        return this.datePickerProps.defaultTime
      }
    },

    format() {
      if (this.datePickerProps.format) {
        return this.datePickerProps.format
      }
    },

    valueFormat() {
      if (this.datePickerProps.value_format) {
        return this.datePickerProps.value_format
      }
    }
  },

  methods: {
    filter() {
      this.restList.filterField(this.prop, this.value)
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/common/components/rest/RestListFilterDate.vue